export default "__VITE_ASSET__944a44d5__"